import React from 'react';
import { FiDownload, FiFile } from 'react-icons/fi';

const DetailDokumen = ({ files }) => {
  if (!files || files.length === 0) return null;

  return (
    <div className="bg-[var(--bg-primary)] p-4 rounded-xl shadow-[var(--shadow-sm)] border border-[var(--border-color)]">
      <h3 className="text-base font-semibold text-[var(--text-primary)] mb-3">
        Dokumen & File ({files.length})
      </h3>
      
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {files.map((file) => (
          <div key={file.id} className="relative group">
            {file.type && file.type.startsWith('image/') ? (
              <img
                src={file.data}
                alt={file.name}
                className="w-full h-32 object-cover rounded-lg border border-[var(--border-color)]"
              />
            ) : (
              <div className="w-full h-32 bg-[var(--bg-secondary)] rounded-lg border border-[var(--border-color)] flex flex-col items-center justify-center gap-1">
                <FiFile size={28} className="text-red-500" />
                <span className="text-[10px] text-[var(--text-secondary)] px-2 text-center truncate w-full">
                  {file.name}
                </span>
              </div>
            )}
            
            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all rounded-lg flex items-center justify-center">
              <a
                href={file.data}
                download={file.name}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity shadow-lg"
                title={`Download ${file.name}`}
              >
                <FiDownload size={18} className="text-gray-700" />
              </a>
            </div>
            
            <p className="text-[10px] text-[var(--text-secondary)] mt-1 truncate" title={file.name}>
              {file.name}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DetailDokumen;